import React from "react";

import { SectionBadges } from "./section-badges";
import { SectionTitle } from "./section-title";

interface RaceAndEthnicityProps {
  items: string[];
}

export const RaceAndEthnicity: React.FC<RaceAndEthnicityProps> = ({
  items,
}) => {
  return (
    <div>
      <SectionTitle title="Race & Ethnicity" />

      <SectionBadges
        bordered
        items={items.length > 0 ? items : ["--"]}
      />
    </div>
  );
};
